import {Component, Input, OnChanges} from '@angular/core';
import {NgIf, NgClass} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {getFullName, getInitials} from '@q9elements/ui-kit/common';

@Component({
  selector: 'app-user-circle',
  templateUrl: './user-circle.component.html',
  styleUrls: ['./user-circle.component.scss'],
  standalone: true,
  imports: [NgIf, MatTooltipModule, MatButtonModule, NgClass]
})
export class UserCircleComponent implements OnChanges {
  initials: string;
  fullName: string;
  avatarUrl: string;

  @Input() user: any;
  @Input() disabled: boolean;
  @Input() locked: boolean;
  @Input() tooltip?: string;

  constructor() {}

  ngOnChanges() {
    if (this.user) {
      if (this.user.firstName || this.user.lastName) {
        this.initials = getInitials(this.user);
        this.fullName = getFullName(this.user);
      } else {
        this.initials = this.fullName = '?';
      }

      this.avatarUrl = this.user.avatar_md;
    }
  }
}
